<template>
    <div class="answer">
        <div class="answer-page">
            <!-- 多题模式选项 -->
            <div class="answer-page--main">
                <div class="testPaper-title">{{ testPaperDetail.paperName }}</div>
                <div style="margin-bottom: 20px; padding:0 50px;" v-if="testPaperDetail.testDuration">
                    倒计时：
                    <bc-count-down style="color: #ff5353;" :end-time="lastTime" :callback="endTime"></bc-count-down>
                </div>
                <div class="test-paper">
                    <el-scrollbar style="height: 100%" wrap-class="test-paper-wrap" view-class="test-paper-view">
                        <div style="padding:0px 20px 20px 40px" class="scrool_ybox">
                            <div v-for="(question, questionIndex) in paperList" :key="questionIndex"
                                :id="`bc-answer-question ${questionIndex}`">
                                <bc-answer-question :dict="{ label: dict.label }"
                                    :class="`answer-module-${moduleIndex}--question-${questionIndex}`"
                                    :question="question" :seq="questionIndex + 1" :key="questionIndex" :typeOk="typeOk"
                                    :styleType="styleType" aishow="false"
                                    @change="changeAnswerv2(questionIndex, $event)"
                                    @changeCancel="changeCancel(questionIndex, $event)"></bc-answer-question>
                            </div>
                            <el-button :disabled="disabled" class="submitBtn" @click="submitTestPaper">提交问卷</el-button>
                        </div>
                    </el-scrollbar>
                </div>
            </div>
        </div>
        <robot style="z-index: 9999" v-if="isShowAi" ref="robotBox" :goodsId="goodsId" :bookName="bookdetail" />
    </div>
</template>
<script>
import robot from "@/components/robot.vue";
import { robotBook } from "@/utils/config.js";
import XEUtils from "xe-utils";
import { paperGetToken } from "@/api/index/index";
import {
    saveAnswerPaperRecordApi,
    getTestPaperExamInfoByIdApi,
    addAnsQuesRecordApi,
    submitAnswerPaperRecordApi
} from "@/api/willingLearn/index.js";
import {
    getTestPaperApi,
    CreateAnswerPaperRecord,
    submitAnswerPaperRecord,
    addAnswerapi,
    getUnSubmitPaperRecord,
    addWrongQuestion,
} from "@/api/answer/answer";
import { MessageBox } from "element-ui";
import { goodsInfoDetail } from "@/api/bookstore/bookstore";

export default {
    components: {
        robot,
    },
    dicts: ["difficulty", "question_type"],
    data() {
        return {
            styleType: 2,
            readtype: "", //阅读类型
            bookdetail: "建筑构造",
            goodsId: "",
            robotBook: "",
            moduleIndex: 0,
            showAi: false,
            loading: false,
            testPaperId: "",
            answerPlatform: "out",
            aprId: "",
            disabled: false,
            testPaperDetail: {},
            lastTime: 0,
            current: 0,
            testPaperRecord: {},
            previewMode: "scrolled", //paginated scrolled
            oIndex: 0,
            answerType: "",
            selectArr: {},
            synArrmoduleIndex: 0,
            synquestionIndex: 0,
            questionId: "",
            answerResults: "",
            typeOk: "other", //false自测和true练习 其他other
            paperList: [],
            questionGrouplist: "",
            answerQuestionRecordList: [],
            testPaperNumber: 0,
            _beforeUnload_time: 0,
            _gap_time: 0,
            height: "",
            activityId: '1818464626657071104',
            paperId: '1818464627940528128',
            activityType: '0', //activityType 0问卷 1 随堂检测
            show: false,

        };
    },
    computed: {
        isShowAi() {
            if (this.robotBook.includes(this.goodsId) && this.typeOk == 'false') {
                return true
            }
            if (this.$store.getters.threePlatform == 'xueKeKnowledgeBaseSys') {
                return true
            }
            if (this.show) {
                return true
            }
            return false
        }
    },
    created() {
        this.robotBook = robotBook;
        this.height = window.innerHeight - 210 + "px";
        // this.previewMode = this.$route.query.previewMode;
    },
    mounted() {
        window.addEventListener("beforeunload", (e) => this.beforeunloadHandler(e));
        window.addEventListener("unload", (e) => this.unloadHandler(e));
        this.goodsId = this.$route.query.goodsId;
        this.bookdetail = this.$route.query.bookName;
        this.testPaperId = this.$route.query.paperId;
        this.typeOk = this.$route.query.typeOk; //自测练习
        this.answerType = this.$route.query.answerType;
        console.log("创建新答题");
        this.saveAnswerPaperRecord();
        this.fixShowAi(this.goodsId)

        // if (this.testPaperId) {
        //     //创建
        //     console.log("创建新答题");
        //     this.createAnswerPaper();
        // } else {
        //     //历史
        //     console.log("历史答题");
        //     this.continueAnsweringQuestions();
        // }
    },
    destroyed() {
        // 关闭浏览器执行退出接口
        window.removeEventListener("beforeunload", (e) =>
            this.beforeunloadHandler(e)
        );
        window.removeEventListener("unload", (e) => this.unloadHandler(e));
    },
    methods: {

        fixShowAi(id) {
            goodsInfoDetail(id).then((res) => {
                if (res.code == 200 && res.data.xiaoZhi) {
                    this.show = true
                }
                else {
                    this.show = false
                }
            })
        },
        openAi(e) {
            var dataAi = e.replace(/<[^>]+>/g, "");
            this.$refs.robotBox.robotShwo = true;
            this.$refs.robotBox.sending(dataAi);
        },
        beforeunloadHandler(e) {
            this._beforeUnload_time = new Date().getTime();
            e = e || window.event;
            if (e) {
                this.requestSubmit()
            }
            return;
        },
        unloadHandler(e) {
            this._gap_time = new Date().getTime() - this._beforeUnload_time;
            debugger;
            //判断是窗口关闭还是刷新
            console.log(this._gap_time);
            debugger;
        },
        // 新增考试记录
        saveAnswerPaperRecord() {
            saveAnswerPaperRecordApi({
                activityId: this.activityId,
                activityType: this.activityType,
                paperId: this.paperId,
            }).then((res) => {
                this.aprId = res.msg;
                this.getTestPaperExamInfoById()
            });
        },
        getTestPaperExamInfoById() {
            getTestPaperExamInfoByIdApi({
                activityId: this.activityId,
                ansRecordId: this.aprId,
                paperId: this.paperId
            }).then(res => {
                this.testPaperDetail = res.data;
                res.data.testPaperModuleList.map((item) => {
                    this.$set(item, "testPaperNumber", this.testPaperNumber);
                    this.testPaperNumber += item.questionList.length;
                    this.paperList = this.paperList.concat(item.questionList);
                });
                this.paperList.map((item) => {
                    this.$set(item, "isAnswer", false); //回答是否正确
                });
                if (this.testPaperDetail.testDuration) {
                    let date = new Date();
                    let min = date.getMinutes();
                    console.log(min + this.testPaperDetail.testDuration)
                    date.setMinutes(min + this.testPaperDetail.testDuration);
                    this.lastTime = date.getTime();
                    console.log(this.lastTime)

                }
            });
        },

        //  新增答题记录
        createAnswerRecord(userAnswer, current) {
            let answerOption = ''
            // 如果是选择和判断题，将当前选项保存到数据库中
            if (this.paperList[current].questionType == 1 || this.paperList[current].questionType == 2 || this.paperList[current].questionType == 3) {
                answerOption = this.paperList[current].questionOption
            }
            let answerData = {
                questionId: this.paperList[current].id,
                paperId: this.paperId,
                activityId: this.activityId,
                activityType: this.activityType,
                aprId: this.aprId,
                answerDate: XEUtils.toDateString(new Date(), "yyyy-MM-dd HH:mm:ss"),
                answerResults: userAnswer,
                answerOption: answerOption,
            }
            addAnsQuesRecordApi(answerData).then((res) => {
                //答题记录的id
                if (res.code == 500) {
                    this.requestSubmit()
                }
            })
        },

        // 确认提交试题
        requestSubmit() {
            const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            submitAnswerPaperRecordApi({
                paperId: this.paperId,
                id: this.aprId,
            }).then((res) => {
                if (res.code == 200) {
                    loading.close();
                    this.$message.success("提交成功");
                    this.disabled = true;
                    this.$router.go(-1)
                }
            })
        },

        // 继续答题
        continueAnsweringQuestions() {
            paperGetToken().then((token) => {
                getUnSubmitPaperRecord({
                    answerPlatform: "out",
                    paperId: "",
                    userId: this.$store.getters.userId,
                    params1: this.goodsId,
                    token: token.data,
                }).then((res) => {
                    if (res.code == 200) {
                        this.testPaperDetail = res.data.tTestPaperDetailInfoVo;
                        this.aprId = res.data.answerQuestionRecordList[0].aprId;
                        if (res.data.tTestPaperDetailInfoVo.testPaperModuleList) {
                            this.testPaperId =
                                res.data.tTestPaperDetailInfoVo.testPaperModuleList[0].paperId;
                            res.data.tTestPaperDetailInfoVo.testPaperModuleList.map(
                                (item) => {
                                    this.paperList = this.paperList.concat(item.questionList);
                                }
                            );
                            this.answerQuestionRecordList = res.data.answerQuestionRecordList;
                            this.paperList.map((item, index) => {
                                this.$set(item, "isAnswer", false); //回答是否正确
                                let paperIndex = this.answerQuestionRecordList.filter(
                                    (value) => {
                                        if (value.questionGroupId) {
                                            return item.id == value.questionGroupId;
                                        } else {
                                            return item.id == value.questionId;
                                        }
                                    }
                                );
                                // console.log("paperIndex", paperIndex);
                                //返回多个为题组  一个为普通试题
                                if (paperIndex.length == 1) {
                                    // 判断保存
                                    if (paperIndex[0].answerResults) {
                                        this.$set(
                                            this.paperList[index],
                                            "standardAnswer",
                                            item.standardAnswer
                                        );
                                        this.$set(this.paperList[index], "selectAnswer", true);
                                        this.$set(this.paperList[index], "isAnswer", true);
                                        this.$set(
                                            this.paperList[index],
                                            "isAnswerResults",
                                            paperIndex[0].answerResults
                                        );
                                    }
                                } else {
                                    // 题组类型继续答题回显
                                    this.$set(this.paperList[index], "isAnswer", true);
                                    console.log("paperIndexpaperIndex", paperIndex);
                                    console.log("paperList", this.paperList);
                                    paperIndex.map((items) => {
                                        // 乱序的时候选项也是乱序先找的对应的index
                                        let lxindex = this.paperList[index].questionList.findIndex(
                                            (item) => {
                                                return item.id == items.questionId;
                                            }
                                        );
                                        console.log("lxindex", lxindex);
                                        // 用户答案
                                        this.$set(
                                            this.paperList[index].questionList[lxindex],
                                            "isAnswerResults",
                                            items.answerResults
                                        );
                                        // 标准答案
                                        this.$set(
                                            this.paperList[index].questionList[lxindex],
                                            "standardAnswer",
                                            item.questionList[lxindex].standardAnswer
                                        );
                                        this.$set(
                                            this.paperList[index].questionList[lxindex],
                                            "selectAnswer",
                                            true
                                        );
                                        // 是否作答
                                        this.$set(
                                            this.paperList[index].questionList[lxindex],
                                            "isAnswer",
                                            true
                                        );
                                    });
                                }
                            });
                            // 根据是否作答排序
                            this.paperList = this.paperList.sort(
                                (a, b) => b.isAnswer - a.isAnswer
                            );
                            console.log("this.paperList2", this.paperList);
                        }
                    }
                });
            });
        },

        //跳转
        toQuestion(e, index) {
            if (this.previewMode == "scrolled") {
                var target = document.getElementById(`bc-answer-question ${index}`);
                target.parentNode.scrollTop = target.offsetTop;
            }
            this.moduleIndex = e;
            this.questionIndex = index;
            if (this.$refs.cardShowx) {
                this.$refs.cardShowx.setActiveItem(index);
            }
        },

        // 下一题
        nexts(e) {
            this.$refs.cardShowx.next();
        },
        // 上一题
        prevs() {
            this.$refs.cardShowx.prev();
        },
        //保存历史进度
        practicePaper() {
            window.close();
        },
        //题组回显
        changeCancel(questionIndex, val) {
            console.log(questionIndex, val);
            let answerResults = val.value;
            if (!answerResults) return;
            if (val.questionIndex || val.questionIndex === 0) {
                console.log("题组下面的第" + (val.questionIndex + 1) + "个小题");
                answerResults = val.value.value;
                let questionGroup = this.paperList[questionIndex]["questionList"];
                this.$set(
                    this.paperList[questionIndex]["questionList"][val.questionIndex],
                    "isAnswer",
                    !!answerResults
                );
                let questionGroupAll = questionGroup.every((i) => i.isAnswer);
                this.$set(this.paperList[questionIndex], "isAnswer", questionGroupAll);
            }
            paperGetToken().then((token) => {
                //保存进度
                let params = {
                    questionId:
                        this.paperList[questionIndex].questionList[val.questionIndex].id,
                    answerPlatform: this.answerPlatform,
                    userId: this.$store.getters.userId,
                    userName: this.$store.getters.userName,
                    paperId: this.testPaperId,
                    answerDate: XEUtils.toDateString(new Date(), "yyyy-MM-dd HH:mm:ss"),
                    answerResults:
                        this.paperList[questionIndex].questionList[val.questionIndex]
                            .isAnswerResults.value,
                    aprId: this.aprId,
                    params1: this.goodsId,
                    token: token.data,
                };
                addAnswerapi(params).then((res) => {
                    if (this.typeOk == "false") {
                        if (res.data.answerQuestionRecord.answerSituation == 0) {
                            this.addErrorBook();
                        }
                        this.$set(
                            this.paperList[questionIndex]["questionList"][val.questionIndex],
                            "standardAnswer",
                            res.data.standardAnswer
                        );
                        this.$set(
                            this.paperList[questionIndex]["questionList"][val.questionIndex],
                            "selectAnswer",
                            true
                        );
                    }
                });
            });
        },
        //选好了回显
        cancels(item, index) {
            let val = this.questionGrouplist;
            let questionIndex = index;
            let answerResults = item.isAnswerResults;
            if (!answerResults) return;
            if (val.questionIndex || val.questionIndex === 0) {
                console.log("题组下面的第" + (val.questionIndex + 1) + "个小题");
                answerResults = val.value.value;
                let questionGroup = this.paperList[questionIndex]["questionList"];
                this.$set(
                    this.paperList[questionIndex]["questionList"][val.questionIndex],
                    "isAnswer",
                    !!answerResults
                );
                let questionGroupAll = questionGroup.every((i) => i.isAnswer);
                this.$set(this.paperList[questionIndex], "isAnswer", questionGroupAll);
            } else {
                this.$set(this.paperList[questionIndex], "isAnswer", !!answerResults);
                paperGetToken().then((token) => {
                    //保存进度
                    let params = {
                        questionId: item.id,
                        answerPlatform: this.answerPlatform,
                        userId: this.$store.getters.userId,
                        userName: this.$store.getters.userName,
                        paperId: this.testPaperId,
                        answerDate: XEUtils.toDateString(new Date(), "yyyy-MM-dd HH:mm:ss"),
                        answerResults: this.paperList[index].isAnswerResults,
                        aprId: this.aprId,
                        params1: this.goodsId,
                        token: token.data,
                    };
                    addAnswerapi(params).then((res) => {
                        console.log("答题", res);
                        if (this.typeOk == "false" || this.typeOk == "other") {
                            if (res.data.answerQuestionRecord.answerSituation == 0) {
                                this.addErrorBook();
                            }
                            this.$set(
                                this.paperList[index],
                                "standardAnswer",
                                res.data.standardAnswer
                            );
                            this.$set(
                                this.paperList[index],
                                "astatistics",
                                res.data.astatistics
                            );
                            this.$set(this.paperList[index], "selectAnswer", true);
                        }
                    });
                });
            }
        },
        async changeAnswer(moduleIndex, questionIndex, val) {
            console.log(val);
            let questionId = val.questionId;
            let answerResults = val.value;
            if (val.questionIndex || val.questionIndex === 0) {
                console.log("题组下面的第" + (val.questionIndex + 1) + "个小题");
                questionId = val.value.questionId;
                answerResults = val.value.value;
                let questionGroup =
                    this.testPaperDetail.testPaperModuleList[moduleIndex]["questionList"][
                    questionIndex
                    ]["questionList"];
                this.$set(
                    this.testPaperDetail.testPaperModuleList[moduleIndex]["questionList"][
                    questionIndex
                    ]["questionList"][val.questionIndex],
                    "isAnswer",
                    !!answerResults
                );

                let questionGroupAll = questionGroup.every((i) => i.isAnswer);
                this.$set(
                    this.testPaperDetail.testPaperModuleList[moduleIndex]["questionList"][
                    questionIndex
                    ],
                    "isAnswer",
                    questionGroupAll
                );
            } else {
                this.$set(
                    this.testPaperDetail.testPaperModuleList[moduleIndex]["questionList"][
                    questionIndex
                    ],
                    "isAnswer",
                    !!answerResults
                );
            }
            console.log(
                `模块${moduleIndex}-第${questionIndex}题-回答的是：${answerResults}`
            );
            paperGetToken().then((token) => {
                //保存进度
                let params = {
                    questionId,
                    answerPlatform: this.answerPlatform,
                    userId: this.$store.getters.userId,
                    userName: this.$store.getters.userName,
                    paperId: this.testPaperId,
                    answerDate: XEUtils.toDateString(new Date(), "yyyy-MM-dd HH:mm:ss"),
                    answerResults,
                    aprId: this.aprId,
                    params1: this.goodsId,
                    token: token.data,
                };
                addAnswerapi(params).then((res) => {
                    if (this.typeOk == "false") {
                        if (res.data.answerQuestionRecord.answerSituation == 0) {
                            this.addErrorBook();
                        }
                    }
                });
            });
        },
        //添加错题本
        addErrorBook() {
            paperGetToken().then((token) => {
                localStorage.setItem('paperToken', token.data)
                addWrongQuestion({
                    questionId: this.paperList[this.synquestionIndex].id,
                    answerPlatform: "out",
                    userId: this.$store.getters.userId,
                    paperId: this.testPaperId,
                    aprId: this.aprId,
                    goodId: this.goodsId,
                });
            });
        },

        //提交试卷
        async submitTestPaper() {
            if (this.testPaperDetail.testDuration) {
                this.$confirm("问卷时间还未结束，是否提前交卷？", "提示")
                    .then(async (res) => {
                        if (res === "confirm") {
                            this.requestSubmit();
                        }
                    })
                    .catch(() => { });
            }
        },
        //结束
        endTime() {
            MessageBox.confirm("问卷时间已结束，正在交卷", "提示", {
                closeOnClickModal: false,
                showClose: false,
                showCancelButton: false,
                closeOnPressEscape: false,
                showConfirmButton: false,
            }).then((res) => {
                if (res === "confirm") {
                    this.requestSubmit();
                }
            });
            setTimeout(() => {
                MessageBox.close();
                this.requestSubmit();
            }, 2000);
        },
        //选择的回调
        async changeAnswerv2(questionIndex, val) {
            //回显模块的
            this.createAnswerRecord(val.value, questionIndex)
        },
    },
};
</script>
<style scoped lang="scss">
.answer {
    width: 1000px;
    height: 100%;
    // background: #f2f2f2;
    margin: 0 auto;

    .testPaper-title {
        text-align: center;
        padding: 18px;
        font-size: 16px;
        color: #333;
        position: relative;
        line-height: 20px;
    }

    .answer-page {
        display: flex;
        padding-bottom: 20px;

        .answer-page--sidebar {
            width: 304px;
            background: #fffefd;
            border-radius: 6px;
            margin-right: 16px;
            display: flex;
            flex-direction: column;
            overflow-y: auto;

            .count-down {
                padding: 10px 20px 0;
            }

            .sidebar-content {
                .moduleContent {
                    padding-bottom: 20px;
                    flex: 1;
                    height: calc(100vh - 340px);
                    overflow-y: scroll;

                    &::-webkit-scrollbar,
                    &::-webkit-scrollbar {
                        /*滚动条整体样式*/
                        width: 6px;
                        /*高宽分别对应横竖滚动条的尺寸*/
                        height: 1px;
                    }

                    // 滚动条样式1
                    &::-webkit-scrollbar-thumb {
                        /*滚动条里面小方块*/
                        border-radius: 3px;
                        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
                        background: #dcdee2;
                    }

                    // 滚动条样式2
                    &::-webkit-scrollbar-thumb {
                        /*滚动条里面小方块*/
                        border-radius: 2px;
                        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
                        background: #dcdee2;
                    }

                    .module {
                        padding: 20px 20px 10px;

                        &+.module {
                            border-top: 1px solid #f2f2f2;
                        }

                        .module-name {
                            font-size: 14px;
                            color: #333333;
                            margin-bottom: 15px;
                        }

                        .module-question {
                            margin-left: -5px;
                            margin-right: -5px;

                            &::after,
                            &::before {
                                display: table;
                                content: "";
                            }

                            &::after {
                                clear: both;
                            }

                            .question-seq {
                                padding-left: 6px;
                                padding-right: 5px;
                                float: left;
                                margin-bottom: 10px;

                                .question-seq--item {
                                    width: 30px;
                                    height: 21px;
                                    line-height: 20px;
                                    text-align: center;
                                    background: #ffffff;
                                    border: 1px solid #2e9adb;
                                    font-size: 14px;
                                    color: #333333;
                                    user-select: none;
                                    cursor: pointer;
                                    transition: all ease 0.3s;

                                    &.isAnswer {
                                        background: #2e9adb;
                                        color: #fff;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        .answer-page--main {
            width: 1080px;
            // height: calc(100vh - 150px);
            background: #fffefd;
            border-radius: 6px;
            overflow: hidden;
            flex-direction: column;

            .test-paper {
                flex: 1;
                min-height: 0;

                ::v-deep .test-paper-wrap {
                    overflow-x: hidden;
                }

                ::v-deep .test-paper-view {
                    padding: 0 10px;
                }

                .paper-module {
                    &+.paper-module {
                        margin-top: 20px;
                    }

                    .paper-module--name {
                        // margin-bottom: 24px;
                    }
                }
            }
        }
    }
}

.submitBtn {
    width: 140px;
    background: #2e9adb;
    border-radius: 6px;
    margin: 50px auto 20px auto;
    text-align: center;
    color: #fff;
    display: block;
}

.tips {
    padding: 0px 20px 0px;
    margin-bottom: 10px;
    display: flex;

    .tips-item {
        display: flex;

        &:last-child {
            margin-left: 20px;
        }

        .status {
            width: 10px;
            height: 10px;
            border: 1px solid #999999;

            &.true {
                background: #2e9adb;
                border-color: #2e9adb;
            }

            &.false {
                background: #fff;
            }
        }

        .text {
            font-size: 12px;
            font-weight: 400;
            color: #999999;
            margin-left: 6px;
        }
    }
}

::v-deep .question {
    height: auto;

    .questionGroupContent {
        display: block;

        .questionType {
            display: inline-block;
        }

        .questionSeq,
        .questionScore {
            display: inline-block;
        }

        .content {
            display: inline;

            .stem-content {
                display: inline;

                .text-break-all {
                    display: inline;

                    p {
                        //display: inline;
                    }
                }
            }
        }
    }

    .group-content {
        display: inline;

        .question {
            padding-left: 20px;
        }
    }

    .stem {
        .stem-box {
            display: block;

            .questionType {
                display: inline-block;
            }

            .questionSeq,
            .questionScore {
                display: inline-block;
            }

            .content {
                display: inline;

                .stem-content {
                    display: inline;

                    .text-break-all {
                        display: inline;

                        p {
                            //display: inline;
                        }
                    }
                }
            }
        }
    }

    .option-item {
        .questionType {
            display: inline-block;
        }

        .questionSeq,
        .questionScore {
            display: inline-block;
        }

        .content {
            display: block;

            .stem-content {
                display: block;

                .text-break-all {
                    display: block;

                    p {
                        display: block;
                    }
                }
            }
        }
    }
}

.dot-title {
    text-align: center;
    margin: 10px 0;
}

.answerBut {
    width: 500px;
    margin: 20px auto;
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding-top: 20px;
}

.button_row {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 20px;
}

.answer_overflow {
    height: calc(100vh - 300px);
    overflow-y: scroll;
}

.carousel_item {
    width: 900px;
}

.carousel_box {
    width: 1000px;
}

.scrool_ybox {
    overflow-x: auto;
    height: 780px;
    margin-bottom: 10px;
}

.but_sub {
    width: 140px;
    background: #2e9adb;
    border-radius: 6px;
    margin: 0 auto;
    text-align: center;
    color: #fff;
    display: block;
    padding: 5px 10px;
}
</style>